import styled from 'styled-components';

export const ContainerStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const MessageStyled = styled.em`
  line-height: 24px;
  padding-left: 8px;
`;
